/**
 * Search Wikimedia Tool Schema
 *
 * Search Wikimedia Commons for images.
 */
import { z } from "zod";
// ═══════════════════════════════════════════════════════════════════════════
// PARAMS SCHEMA
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Image type enum for filtering search results
 */
export const ImageTypeEnum = z.enum(["executive_headshot", "product_image", "general"]);
/**
 * Search Wikimedia parameters
 */
export const SearchWikimediaParamsSchema = z.object({
    uiDescription: z.string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    query: z.string()
        .min(1, "Query cannot be empty")
        .describe("Search term (e.g., 'Satya Nadella')"),
    imageType: ImageTypeEnum
        .describe("Type of image to search for: 'executive_headshot', 'product_image', or 'general'"),
    limit: z.number()
        .int()
        .min(1)
        .max(50)
        .optional()
        .default(10)
        .describe("Maximum number of results to return (default: 10)"),
});
